import React, { useState, useEffect } from 'react'
import fire from './fire.js'
import Login from './Auth/Login'
import Register from './Auth/Register'
import { Route, Switch, BrowserRouter as Router, Link } from 'react-router-dom'
// import QuizBlocked from './quiz/QuizBlocked'
// import PageNotFound from './PageNotFound';
import Quiz from './quiz/Quiz.js'
// import axios from 'axios'


// axios.defaults.withCredentials = true;
const App = () => {
  // const [user, setUser] = useState('');
  // const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  // const [emailError, setEmailError] = useState('');
  // const [passwordError, setPasswordError] = useState('');
  // const [hasAccount, setHasAccount] = useState(false);
  // const [quizAccess, setQuizAccess] = useState(false);
  // const [qt, setQt] = useState(null);
  // const clearInput = () => {
  //   setEmail('');
  //   setPassword('');
  // }
  // const clearErrors = () => {
  //   setEmailError('');
  //   setPasswordError('');
  // }
  // const handleLogin = () => {
  //   clearErrors();
  //   fire.auth().signInWithEmailAndPassword(email,password).catch(
  //     err =>{
  //       alert(err.message)
  //     }
  //   )
  // }
  // const handleSignup = async () => {
  //   clearInput();
  //   await fire.auth().createUserWithEmailAndPassword(email,password).then(
  //     () => {
  //      fire.firestore().collection("users").doc(email).set({
  //        email:email,
  //        quizaccess:true,
  //      }).then(() => {
  //       fire.firestore().collection("quizans").doc(email).set({
  //         mcq:0,
  //         spotTest:0,
  //         dataAnalysis:0,
  //       })
  //      }).then(() => {
  //        alert("Successfully Registered, Please Proceed Towards")
  //        handleSignout();
  //      }).catch((error) => {
  //        alert(error)
  //      }) 
  //     }
  //   ).catch(
  //     err =>{
  //       alert(err.message)

  //     }
  //   )
  // }
  // const handleSignout = () =>{
  //   fire.auth().signOut();
  // }
  // const authState = async () => {
  //   await fire.auth().onAuthStateChanged(async user =>{
  //    if (user) {
  //      setUser(user)
  //    } else {
  //      setUser("")
  //      await fire.firestore().collection("users").doc(user.email).update({
  //       quizaccess:false,
  //      }).catch(
  //        err=>console.log(err)
  //      )
  //    } 
  //   })
  // }
  
  // function closeIt()
  // {
  //   alert("closing")
  //   fire.firestore().collection("users").doc(user.email).update({
  //     quizaccess:false,
  //   })
  // }
  
  // onbeforeunload = closeIt;

  // useEffect(() => {
  //   // authState();
  // }, []);

  // useEffect(async () => {
  //   await fire.firestore().collection("users").doc(user.email).onSnapshot(async (doc) => {
  //       if (doc.exists) {
  //         await setQuizAccess(doc.data().quizaccess)
 
    
  //       } else {
  //           console.log("No such document!");
  //       }
  //   });

  //   fire.firestore().collection("timer").doc("opt").onSnapshot((doc) => {
  //     if (doc.exists) {
  //       setQt(doc.data().qt)
  //     } else {
  //         console.log("No such document!");
  //     }
  // })
  // })



  return ( 
    <div className="app">
    {
      
        <Router>
        <Switch>
        <Route exact path="/">
        <Quiz/>
      
        {/*quizAccess?(
          <Quiz User={user.email} qtTimer={qt} palayn={handleSignout}/>
        ):(
          <QuizBlocked/>
        )*/}
        </Route>
        
        </Switch>
        </Router>
      
    }

    
    </div>
   );
}
 
export default App;

